import { catalogProvider } from "./providers/catalog";
import {
  validateGetCatalogImportDetailsRequest,
  validateGetCatalogsRequest,
} from "./schemas/catalogSchemas";

const catalog = {

    modifica:async(data) =>{
        try {
            return await catalogProvider.modifica(data);
        } catch (error) {
            console.error('Errore', error);
            throw error;
        }
    },
    elimina:async(data) =>{
        try {
            return await catalogProvider.elimina(data);
        } catch (error) {
            console.error('Errore', error);
            throw error;
        }
    },
   getCatalogs:async(data) =>{
        try {
            const payload = validateGetCatalogsRequest(data);
            return await catalogProvider.getCatalogs(payload);
        } catch (error) {
            console.error('Errore durante la richiesta get Catalogs:', error);
            throw error;
        }
    },
    getCatalogImportDetails:async(data) =>{
        try {
            const payload = validateGetCatalogImportDetailsRequest(data);
            return await catalogProvider.getCatalogImportDetails(payload);
        } catch (error) {
            console.error('Errore durante la richiesta get Catalog Import Details:', error);
            throw error;
        }
    },
    importCsv: async(data) =>{
        try {
            return await catalogProvider.importCsv(data);
        } catch (error) {
            console.error('Errore durante la richiesta Import Catalog:', error);
            throw error;
        }
    }
}

export default catalog;